import { NavigationItem } from '@/types';

export const navigationItems: NavigationItem[] = [
  { href: '#services', label: 'Engagements' },
  { href: '#about', label: 'How I work' },
  { href: '#projects', label: 'Past work' },
  { href: '#contact', label: 'Contact' },
];

export const companyInfo = {
  name: 'Red Eye Development',
  tagline: 'The expensive mistakes happen before anyone writes code.',
  description:
    'Independent technical guidance for founders on the calls that come first: architecture, stack, and who builds it. So you don’t spend months and real money finding out the hard way.',
  // No phone. The 833 line is being cancelled, so email is the only contact
  // channel. Do not reintroduce a number here without a live line behind it.
  email: 'howdy@redeye.dev',
  copyright: 'Red Eye Development, LLC © 2025',
};
